import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import flask from "../../resources/img/flask.png";
import bloodPressure from "../../resources/img/bloodpressure1.svg";
import survey from "../../resources/img/survey.png";
import React, {useContext} from "react";
import InitContext from "../pages/InitContext";

const Diary = () => {
  const { t: t } = useTranslation();
  const context = useContext(InitContext);

  return (
    <div className="w3-display-container content-container">
      <div style={{ width: '100%', textAlign: 'right', paddingRight: "20px" }}>
        <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
      </div>
      <div className="w3-display-middle w3-center form-display">
        <header className="w3-container w3-center w3-padding-small">
          <h2>{t("my_diary")}</h2>
        </header>
        <div className="w3-row">
          <div className="w3-third">
            <Link to={"/symptoms"}>
              <div className="w3-container">
                <div className="w3-btn w3-round-xlarge w3-theme-d5">
                  {t("symptoms")}
                </div>
                <div className="w3-display-container w3-panel w3-card-4 home-panel">
                  <label className="home-text">
                    {t("here_you_can_report_your_symptoms")}
                  </label>
                  <img
                    src={survey}
                    alt="Symptoms"
                    className="w3-display-bottommiddle home-icon"
                  />
                </div>
              </div>
            </Link>
          </div>
          <div className="w3-third">
            <Link to={"/labValues"}>
              <div className="w3-container">
                <div className="w3-btn w3-round-xlarge w3-theme-d5">
                  {t("lab_values")}
                </div>
                <div className="w3-display-container w3-panel w3-card-4 home-panel">
                  <label className="home-text">
                    {t("here_you_can_enter_your_laboratory_test_data")}
                  </label>
                  <img
                    src={flask}
                    alt="Lab Values"
                    className="w3-display-bottommiddle home-icon"
                  />
                </div>
              </div>
            </Link>
          </div>
          <div className="w3-third">
            <Link to={"/measurements"}>
              <div className="w3-container">
                <div className="w3-btn w3-round-xlarge w3-theme-d5">
                  {t("measurements")}
                </div>
                <div className="w3-display-container w3-panel w3-card-4 home-panel">
                  <label className="home-text">
                    {t("here_you_can_enter_your_measurements")}
                  </label>
                  <img
                    src={bloodPressure}
                    alt="Measurements"
                    className="w3-display-bottommiddle home-icon"
                  />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Diary;
